import { CENTER_TOKEN_KEY } from "@/constants/common";
import { PRODUCT_CODE_QUERY_KEY, REDIRECT_URL_QUERY_KEY } from "@/features/auth/constant/login";
import { AppRoutes } from "@/routes/config";
import { createUrlWithParams, getSafeRedirectURL } from "@/utils/url";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Guard for guest-only pages (login, *-complete, ...).
 * If a valid token already exists, redirect to the home page instead of rendering the page.
 */
export const withGuest: <CP extends {}>(WrappedComponent: FC<CP>) => FC<CP> = (WrappedComponent) => (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!Cookies.get(CENTER_TOKEN_KEY));
  const [searchParams] = useSearchParams();

  // Re-check auth every 5s so a token acquired in another tab redirects the guest away.
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAuthenticated(!!Cookies.get(CENTER_TOKEN_KEY));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const redirectUrl = searchParams.get(REDIRECT_URL_QUERY_KEY);
  const productCode = searchParams.get(PRODUCT_CODE_QUERY_KEY);

  if (isAuthenticated) {
    if (productCode) {
      const url = createUrlWithParams(AppRoutes.mintOauthRedirect, { productCode, redirectUrl });
      return <Navigate to={url} replace />;
    }
    return <Navigate to={getSafeRedirectURL(redirectUrl)} replace />;
  }

  return <WrappedComponent {...props} />;
};
